import { css } from '@emotion/react'

import * as styles from '@twisto/styles'
import { size } from '@twisto/styles'

export const container = css`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  margin-top: ${styles.size[32]};
`

export const passwordStrengthSection = css`
  margin-top: ${size[16]};
  margin-bottom: ${size[32]};
`
